'use client';
import { cn } from '@/lib/utils';

interface TextAreaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  icon?: React.ReactNode;
  clearable?: boolean;
  error?: boolean;
}

export function Textarea({
  icon,
  clearable,
  className,
  error,
  value,
  onChange,
  ...props
}: TextAreaProps) {
  let paddingY = '';
  if (icon) paddingY += 'pl-[38px] ';
  if (clearable) paddingY += 'pr-[38px]';

  return (
    <div className='relative w-full'>
      {icon && (
        <span className='absolute top-[16px] left-[16px]'>
          {icon}
        </span>
      )}
      <textarea
        className={cn(
          'w-full px-[16px] py-[12px] border rounded-sm bg-component-secondary focus:border-primary focus:outline-none focus:ring-0',
          error && 'border-negative focus:border-negative',
          props.disabled &&
            'bg-disabled cursor-not-allowed',
          paddingY,
          className
        )}
        value={value ?? ''}
        onChange={onChange}
        {...props}
      />
    </div>
  );
}
